import produce from 'immer';
import { registerReducer } from '../../../StateSetup/RootReducer';

const { BFF_URL, GBCORE_CLIENT_NAME, GBCORE_CLIENT_VERSION } = window.__ENV__;

// Action names
const ACTION_NAME_PREFIX = 'action/commitContext';
export const REQUEST_ACTION_NAME = `${ACTION_NAME_PREFIX}/request`;
export const RESPONSE_ACTION_NAME = `${ACTION_NAME_PREFIX}/response`;
export const ERROR_ACTION_NAME = `${ACTION_NAME_PREFIX}/error`;

/**
 * Performs the CommitChanges mutation to commit and context from previous no-commit mutation
 * @returns response from CommitChangesMutation
 */
export const CommitContext = () => {
    return async (dispatch, getState, { logger }) => {
        const { jwt, sessionCorrelationId } = getState().Authentication;
        const transactionId = logger.generateGuid();

        // step 1: Request Action
        dispatch({ type: REQUEST_ACTION_NAME });

        logger.info(`${ACTION_NAME_PREFIX}: Comitting context.`, {
            correlation: { transactionId },
        });

        const commitContextMutation = await fetch(`${BFF_URL}/api/v2`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'gb-authorization': jwt,
                'mli-session-correlation-id': sessionCorrelationId,
                'mli-correlation-id': transactionId,
                'mli-channel': 'web',
                'gb-client-name': GBCORE_CLIENT_NAME,
                'gb-client-version': GBCORE_CLIENT_VERSION,
                'is-event-only-session': true,
            },
            body: JSON.stringify({
                operationName: 'CommitChangesMutation',
                variables: {},
                query: `
                    mutation CommitChangesMutation {
                        commitContext {
                            ContextToVoKeyMap {
                                ContextKey
                                VoKey
                            }
                        }
                    }            
            `,
            }),
        });

        const commitContextMutationResponse = await commitContextMutation.json();

        if (commitContextMutationResponse.errors) {
            const { message, code } = commitContextMutationResponse.errors[0];
            logger.critical(
                `${ACTION_NAME_PREFIX}: Failure when committing member data. Code: ${code} Reason: ${message}`,
                { correlation: { transactionId } }
            );
            return dispatch({
                type: ERROR_ACTION_NAME,
                code,
                message,
            });
        }

        return dispatch({ type: RESPONSE_ACTION_NAME, data: commitContextMutationResponse.data, success: true });
    };
};

export const requestReducer = produce((state) => {
    state.MemberData.isCommitContextSaving = true;
});

export const responseReducer = produce((state) => {
    state.MemberData.isCommitContextSaving = false;
});

export const errorReducer = produce((state, action) => {
    state.MemberData.isCommitContextSaving = false;
    state.Errors.commitContext.hasError = true;
    state.Errors.commitContext.code = action.code;
    state.Errors.commitContext.message = action.message;
});

registerReducer(REQUEST_ACTION_NAME, requestReducer);
registerReducer(RESPONSE_ACTION_NAME, responseReducer);
registerReducer(ERROR_ACTION_NAME, errorReducer);
